import {
  Card,
  CardBody,
  Col,
  Input,
  Nav,
  NavItem,
  NavLink,
  Row,
} from "reactstrap";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";
import AppModal from "../../Common/AppModal";
import classnames from "classnames";
import { isEmpty } from "lodash";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getLicensesSubscriptionList,
  getLicensesSubscriptionProductList,
  requestSubscriptionLicensesOrderPreview,
  requestSubscriptionLicensesOrderPreviewSuccess,
} from "../../../store/manageLicense/action";
import { getStaffList } from "../../../store/staff/action";
import Select from "../../Common/AppSelect";
import ConfirmNewLicenses from "../ConfirmNewLicenses";
import { toast } from "react-toastify";

const AddNewLicense = ({ modal, toggle }) => {
  const licensesInitial = {
    SubscriptionProduct_Id: "",
    Quantity: 1,
    RenewalCycle: "Monthly",
  };
  const dispatch = useDispatch();

  const [licenses, setLicenses] = useState(licensesInitial);
  const [filter, setFilter] = useState("1");
  const [filteredSubscriptionProducts, setFilteredSubscriptionProducts] =
    useState([]);

  const {
    GetSubscriptionList,
    GetSubscriptionListLoading,
    getLicensesSubscriptionProductListAPI,
  } = useSelector((state) => ({
    GetSubscriptionList:
      state.ManageLicense.licensesSubscriptionList?.subscriptionlicence_list,
    GetSubscriptionListLoading:
      state.ManageLicense.licenseSubscriptionListLoading,
    getLicensesSubscriptionProductListAPI:
      state.ManageLicense.licensesSubscriptionProductList
        ?.subscriptionproduct_list,
  }));
  useEffect(() => {
    dispatch(getLicensesSubscriptionList());
    dispatch(getLicensesSubscriptionProductList());
    dispatch(getStaffList());
  }, []);

  useEffect(() => {
    let filteredData = getLicensesSubscriptionProductListAPI;
    filteredData = getLicensesSubscriptionProductListAPI?.filter(
      (item) => item?.FlagTalkToSales === null
    );
    if (filter === "1") {
      filteredData = getLicensesSubscriptionProductListAPI?.filter(
        (item) => item?.SubscriptionLicenceDurationType_Id === "1"
      );
    }
    if (filter === "2") {
      filteredData = getLicensesSubscriptionProductListAPI?.filter(
        (item) => item?.SubscriptionLicenceDurationType_Id === "2"
      );
    }
    if (filter === "all") {
      filteredData = getLicensesSubscriptionProductListAPI;
    }
    filteredData = filteredData?.filter(
      (item) => item.FlagAllowFrontEndPurchase === "1"
    );
    setFilteredSubscriptionProducts(filteredData);
  }, [getLicensesSubscriptionProductListAPI, filter]);
  const handleRequestNewLicensesPreview = (productId) => {
    const licenseData = {
      subscriptionproduct_list: [
        {
          Id: productId,
          Quantity: licenses.Quantity,
        },
      ],
    };
    dispatch(requestSubscriptionLicensesOrderPreview([licenseData]));
  };
  const [selectedLicense, setSelectedLicense] = useState(null);

  const {
    subscriptionLicensesOrderPreviewAPI,
    subscriptionLicensesOrderPreviewLoading,
  } = useSelector((state) => ({
    subscriptionLicensesOrderPreviewAPI:
      state.ManageLicense.subscriptionLicensesOrderPreview,
  }));
  const [modalConfirmNewLicenses, setModalConfirmNewLicenses] = useState(false);
  const [previewLicensesSummary, setPreviewLicensesSummary] = useState([]);
  useEffect(() => {
    if (isEmpty(subscriptionLicensesOrderPreviewAPI)) return;
    if (subscriptionLicensesOrderPreviewAPI?.status === 200) {
      setPreviewLicensesSummary(subscriptionLicensesOrderPreviewAPI);
      setModalConfirmNewLicenses(true);
    } else {
      //
      toast.error(subscriptionLicensesOrderPreviewAPI?.message);
    }
    dispatch(requestSubscriptionLicensesOrderPreviewSuccess([]));
  }, [subscriptionLicensesOrderPreviewAPI]);

  const toggleConfirmNewLicenses = () =>
    setModalConfirmNewLicenses(!modalConfirmNewLicenses);

  return (
    <AppModal
      open={modal}
      onClose={toggle}
      title="Add New License"
      icon={<WorkspacePremiumOutlinedIcon />}
      headerAccent="indigo"
      size="md"
      hideFooter
    >
      {modalConfirmNewLicenses && (
        <ConfirmNewLicenses
          licensesData={licenses}
          toggle={toggleConfirmNewLicenses}
          modal={modalConfirmNewLicenses}
          setModal={setModalConfirmNewLicenses}
          previewLicensesSummary={previewLicensesSummary}
          closeModal={toggle}
        />
      )}
        {/*<Col lg={12} id={"AddNewLicense"}>*/}
        {/*  <Card>*/}
        {/*    <CardBody className={"m-0 p-0"}>*/}
        {/*      <Row>*/}
        {/*        <Col lg={12}>*/}
        {/*          <div className={"d-flex flex-row justify-content-center"}>*/}
        {/*            /!*<div className={"pe-2"}>*!/*/}
        {/*            /!*  <div className={"pb-1 "}>Plan selected: </div>*!/*/}
        {/*            /!*  <div className={"pb-2"} style={{ width: "310px" }}>*!/*/}
        {/*            /!*    <Select*!/*/}
        {/*            /!*      options={getLicensesSubscriptionProductListAPI?.map(*!/*/}
        {/*            /!*        (item) => {*!/*/}
        {/*            /!*          return {*!/*/}
        {/*            /!*            label: item?.Name,*!/*/}
        {/*            /!*            value: item?.Id,*!/*/}
        {/*            /!*          };*!/*/}
        {/*            /!*        }*!/*/}
        {/*            /!*      )}*!/*/}
        {/*            /!*      onChange={(e) => {*!/*/}
        {/*            /!*        setLicenses({*!/*/}
        {/*            /!*          ...licenses,*!/*/}
        {/*            /!*          SubscriptionProduct_Id: e.value,*!/*/}
        {/*            /!*        });*!/*/}
        {/*            /!*      }}*!/*/}
        {/*            /!*      value={{*!/*/}
        {/*            /!*        label:*!/*/}
        {/*            /!*          getLicensesSubscriptionProductListAPI?.find(*!/*/}
        {/*            /!*            (item) =>*!/*/}
        {/*            /!*              item?.Id ===*!/*/}
        {/*            /!*              licenses?.SubscriptionProduct_Id*!/*/}
        {/*            /!*          )?.Name,*!/*/}
        {/*            /!*        value: licenses?.SubscriptionProduct_Id,*!/*/}
        {/*            /!*      }}*!/*/}
        {/*            /!*    ></Select>*!/*/}
        {/*            /!*  </div>*!/*/}
        {/*            /!*</div>{" "}*!/*/}
        {/*            <div>*/}
        {/*              <div className={"pb-1"}>*/}
        {/*                How many licenses do you need ?*/}
        {/*              </div>*/}
        {/*              <div className={"  d-flex flex-row"}>*/}
        {/*                <span*/}
        {/*                  className={"me-2 btn btn-soft-info"}*/}
        {/*                  onClick={() => {*/}
        {/*                    //check if not below 0 if it is set to 1*/}
        {/*                    if (licenses.Quantity > 1) {*/}
        {/*                      setLicenses({*/}
        {/*                        ...licenses,*/}
        {/*                        Quantity: Number(licenses.Quantity) - 1,*/}
        {/*                      });*/}
        {/*                    }*/}
        {/*                  }}*/}
        {/*                >*/}
        {/*                  -*/}
        {/*                </span>*/}
        {/*                <Input*/}
        {/*                  placeholder={"1"}*/}
        {/*                  type="number"*/}
        {/*                  style={{*/}
        {/*                    width: "50px",*/}
        {/*                    display: "flex",*/}
        {/*                    justifyContent: "center",*/}
        {/*                  }}*/}
        {/*                  value={licenses.Quantity}*/}
        {/*                  onChange={(e) => {*/}
        {/*                    setLicenses({*/}
        {/*                      ...licenses,*/}
        {/*                      Quantity: e.target.value,*/}
        {/*                    });*/}
        {/*                  }}*/}
        {/*                />*/}
        {/*                <span*/}
        {/*                  className={"ms-2 btn btn-soft-info"}*/}
        {/*                  onClick={() => {*/}
        {/*                    setLicenses({*/}
        {/*                      ...licenses,*/}
        {/*                      Quantity: Number(licenses.Quantity) + 1,*/}
        {/*                    });*/}
        {/*                  }}*/}
        {/*                >*/}
        {/*                  +*/}
        {/*                </span>*/}

        {/*                <div className={"ps-2"}>*/}
        {/*                  <button*/}
        {/*                    className={"btn btn-primary"}*/}
        {/*                    onClick={() => {*/}
        {/*                      //*/}
        {/*                      handleRequestNewLicensesPreview();*/}
        {/*                    }}*/}
        {/*                  >*/}
        {/*                    Request New License*/}
        {/*                  </button>*/}
        {/*                </div>*/}
        {/*              </div>*/}
        {/*            </div>*/}
        {/*          </div>*/}
        {/*        </Col>*/}
        {/*      </Row>*/}
        {/*    </CardBody>*/}
        {/*  </Card>*/}
        {/*</Col>*/}
        <Row className="justify-content-center mt-2">
          <Col lg={12}>
            <div className="text-center mb-2">
              <h4 className="fw-semibold fs-22">Plans & Pricing</h4>
              <p className="text-muted   fs-15">
                Simple pricing. No hidden fees. Advanced features for you
                business.
              </p>

              <div className="d-inline-flex">
                <Nav
                  className="nav-pills arrow-navtabs plan-nav rounded mb-3 p-1"
                  id="pills-tab"
                  role="tablist"
                >
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classnames(
                        { active: filter === "all" },
                        "fw-semibold"
                      )}
                      onClick={() => {
                        setFilter("all");
                      }}
                    >
                      All Plans
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classnames(
                        { active: filter === "1" },
                        "fw-semibold"
                      )}
                      onClick={() => {
                        setFilter("1");
                      }}
                    >
                      Monthly
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href="#"
                      className={classnames(
                        { active: filter === "2" },
                        "fw-semibold"
                      )}
                      onClick={() => {
                        setFilter("2");
                      }}
                    >
                      Annually{" "}
                      <span className="badge bg-success">Best Value</span>
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          {!isEmpty(getLicensesSubscriptionProductListAPI) && (
            <>
              {(filteredSubscriptionProducts || []).map((product, key) => (
                <Col lg={4} key={key}>
                  <Card className="pricing-box ribbon-box right">
                    {product?.FlagRibbonPopular === "1" ? (
                      <div className="ribbon-two ribbon-two-danger">
                        <span>Popular</span>
                      </div>
                    ) : (
                      ""
                    )}
                    <CardBody className="">
                      <div className="d-flex align-items-center">
                        <div className="flex-grow-1">
                          <h5 className="mb-1 fw-semibold">{product.Title}</h5>
                          <p className="text-muted mb-0">
                            {product?.Description}
                          </p>
                        </div>
                        <div className="avatar-sm">
                          <div className="avatar-title bg-light rounded-circle text-primary">
                            <i className={"fs-20 " + product?.FeatureIcon}></i>
                          </div>
                        </div>
                      </div>
                      <div className="pt-2 ">
                        <h3 className={"d-flex align-items-center"}>
                          <small>£ </small>

                          {product?.PreDiscountLocalSubTotal !==
                          product.AmountLocalSubTotal ? (
                            <div className={"pe-1"}>
                              <del>{product.PreDiscountLocalSubTotal}</del>{" "}
                              {product.AmountLocalSubTotal}
                            </div>
                          ) : (
                            <> {product.AmountLocalSubTotal}</>
                          )}

                          <span className="fs-13 text-muted">
                            / {filter === "1" ? "Month" : "Annualy"}
                          </span>
                        </h3>
                      </div>
                      <hr className="my-4 text-muted" />
                      <div>
                        {" "}
                        {!isEmpty(
                          product?.subscriptionproductfeatures_list
                        ) && (
                          <ul className="list-unstyled text-muted vstack gap-3">
                            {product?.subscriptionproductfeatures_list?.map(
                              (item, key) => (
                                <li key={key}>
                                  <div className="d-flex">
                                    <div
                                      className={`flex-shrink-0 text-${item.Class} me-1`}
                                    >
                                      <i
                                        className={`ri-${item.Icon}-circle-fill fs-15 align-middle`}
                                      ></i>
                                    </div>
                                    <div className="flex-grow-1">
                                      {item?.Text}
                                    </div>
                                  </div>
                                </li>
                              )
                            )}

                            {/*<li>*/}
                            {/*  <div className="d-flex">*/}
                            {/*    <div className="flex-shrink-0 text-success me-1">*/}
                            {/*      <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>*/}
                            {/*    </div>*/}
                            {/*    <div className="flex-grow-1">*/}
                            {/*      Upto <b>{product.projects}</b> Projects*/}
                            {/*    </div>*/}
                            {/*  </div>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*  <div className="d-flex">*/}
                            {/*    <div className="flex-shrink-0 text-success me-1">*/}
                            {/*      <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>*/}
                            {/*    </div>*/}
                            {/*    <div className="flex-grow-1">*/}
                            {/*      Upto <b>{product.Customers}</b> Customers*/}
                            {/*    </div>*/}
                            {/*  </div>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*  <div className="d-flex">*/}
                            {/*    <div className="flex-shrink-0 text-success me-1">*/}
                            {/*      <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>*/}
                            {/*    </div>*/}
                            {/*    <div className="flex-grow-1">*/}
                            {/*      Scalable Bandwidth*/}
                            {/*    </div>*/}
                            {/*  </div>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*  <div className="d-flex">*/}
                            {/*    <div className="flex-shrink-0 text-success me-1">*/}
                            {/*      <i className="ri-checkbox-circle-fill fs-15 align-middle"></i>*/}
                            {/*    </div>*/}
                            {/*    <div className="flex-grow-1">*/}
                            {/*      <b>{product.FTP}</b> FTP Login*/}
                            {/*    </div>*/}
                            {/*  </div>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*  <div className="d-flex">*/}
                            {/*    <div*/}
                            {/*      className={`flex-shrink-0 text-${product.supportClass} me-1`}*/}
                            {/*    >*/}
                            {/*      <i*/}
                            {/*        className={`ri-${product.supportClassSymbol}-circle-fill fs-15 align-middle`}*/}
                            {/*      ></i>*/}
                            {/*    </div>*/}
                            {/*    <div className="flex-grow-1">*/}
                            {/*      <b>24/7</b> Support*/}
                            {/*    </div>*/}
                            {/*  </div>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*  <div className="d-flex">*/}
                            {/*    <div*/}
                            {/*      className={`flex-shrink-0 text-${product.storageClass} me-1`}*/}
                            {/*    >*/}
                            {/*      <i*/}
                            {/*        className={`ri-${product.storageClassSymbol}-circle-fill fs-15 align-middle`}*/}
                            {/*      ></i>*/}
                            {/*    </div>*/}
                            {/*    <div className="flex-grow-1">*/}
                            {/*      <b>Unlimited</b> Storage*/}
                            {/*    </div>*/}
                            {/*  </div>*/}
                            {/*</li>*/}
                            {/*<li>*/}
                            {/*  <div className="d-flex">*/}
                            {/*    <div*/}
                            {/*      className={`flex-shrink-0 text-${product.domainClass} me-1`}*/}
                            {/*    >*/}
                            {/*      <i*/}
                            {/*        className={`ri-${product.domainClassSymbol}-circle-fill fs-15 align-middle`}*/}
                            {/*      ></i>*/}
                            {/*    </div>*/}
                            {/*    <div className="flex-grow-1">Domain</div>*/}
                            {/*  </div>*/}
                            {/*</li>*/}
                          </ul>
                        )}
                      </div>
                      {product?.MaxUsers !== "1" && (
                        <div>
                          <hr />
                          <div className={"pb-1"}>
                            How many licenses do you need ?
                          </div>
                          <div
                            className={"d-flex flex-row justify-content-center"}
                          >
                            <span
                              className={"me-2 btn btn-soft-info"}
                              onClick={() => {
                                //check if not below 0 if it is set to 1
                                if (licenses.Quantity > 1) {
                                  setLicenses({
                                    ...licenses,
                                    Quantity: Number(licenses.Quantity) - 1,
                                  });
                                }
                              }}
                            >
                              -
                            </span>
                            <Input
                              placeholder={"1"}
                              type="number"
                              style={{
                                width: "50px",
                                display: "flex",
                                justifyContent: "center",
                              }}
                              value={licenses.Quantity}
                              onChange={(e) => {
                                setLicenses({
                                  ...licenses,
                                  Quantity: e.target.value,
                                });
                              }}
                            />
                            <span
                              className={"ms-2 btn btn-soft-info"}
                              onClick={() => {
                                setLicenses({
                                  ...licenses,
                                  Quantity: Number(licenses.Quantity) + 1,
                                });
                              }}
                            >
                              +
                            </span>

                            {/*<div className={"ps-2"}>*/}
                            {/*  <button*/}
                            {/*      className={"btn btn-primary"}*/}
                            {/*      onClick={() => {*/}
                            {/*        //*/}
                            {/*        handleRequestNewLicensesPreview();*/}
                            {/*      }}*/}
                            {/*  >*/}
                            {/*    Request New License*/}
                            {/*  </button>*/}
                            {/*</div>*/}
                          </div>
                        </div>
                      )}

                      <div className="mt-4">
                        <button
                          disabled={subscriptionLicensesOrderPreviewLoading}
                          className={`btn btn-success w-100 waves-effect waves-light`}
                          onClick={() => {
                            setLicenses({
                              ...licenses,
                              SubscriptionProduct_Id: product?.Id,
                            });
                            handleRequestNewLicensesPreview(product?.Id);
                          }}
                        >
                          {product.ButtonText ?? "Select Plan"}
                        </button>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </>
          )}
        </Row>
    </AppModal>
  );
};

export default AddNewLicense;
